import React, { createContext, useContext, useEffect, useState } from "react";
import { api, extractError } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);       // null = checking, false = unauth, obj = auth
    const [checking, setChecking] = useState(true);

    useEffect(() => {
        (async () => {
            const token = localStorage.getItem("vpn_token");
            if (!token) {
                setAdmin(false);
                setChecking(false);
                return;
            }
            try {
                const { data } = await api.get("/auth/me");
                setAdmin(data);
            } catch {
                setAdmin(false);
                localStorage.removeItem("vpn_token");
            } finally {
                setChecking(false);
            }
        })();
    }, []);

    const login = async (email, password) => {
        try {
            const { data } = await api.post("/auth/login", { email, password });
            localStorage.setItem("vpn_token", data.token);
            setAdmin(data.admin);
            return { ok: true };
        } catch (e) {
            return { ok: false, error: extractError(e) };
        }
    };

    const logout = async () => {
        try { await api.post("/auth/logout"); } catch {}
        localStorage.removeItem("vpn_token");
        setAdmin(false);
    };

    return (
        <AuthCtx.Provider value={{ admin, checking, login, logout, setAdmin }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
